/**
 * @generated SignedSource<<a72e7ad7fded21d963e99e3c9e70c5be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type coachCard_UserFragment$data = {
  readonly coach: {
    readonly extension: {
      readonly firstName?: string;
      readonly lastName?: string;
      readonly position?: string | null;
    } | null;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"userAvatar_UserFragment">;
  } | null;
  readonly id: string;
  readonly profileData: {
    readonly avatar: {
      readonly url: string | null;
    } | null;
    readonly description: string | null;
    readonly jobTitles: ReadonlyArray<string> | null;
  };
  readonly " $fragmentType": "coachCard_UserFragment";
};
export type coachCard_UserFragment$key = {
  readonly " $data"?: coachCard_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"coachCard_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "coachCard_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "coach",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "userExtensionKind",
              "value": "Academies"
            }
          ],
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "position",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "type": "AcademiesUserExtension",
              "abstractKey": null
            }
          ],
          "storageKey": "extension(userExtensionKind:\"Academies\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userAvatar_UserFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileData",
      "kind": "LinkedField",
      "name": "profileData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTitles",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CoachProfile",
  "abstractKey": null
};

(node as any).hash = "59687bbb28f33a9a5213f935cc752a2c";

export default node;
